export default __webpack_public_path__ + "static/media/a4.d4e0a8e3.png";